import { useTranslation } from "react-i18next";
import MaterialTable from "../../../../../projects/EquipmentList/AddEquipment/ModelingEquipment/CarbonEstimation/MaterialTable/MaterialTable";
import { ManufacturerIndexChoice, ManufacturerIndexTitle, MaterialSynthese, MaterialTotalWeight } from "../../../../../projects/EquipmentList/AddEquipment/ModelingEquipment/CarbonEstimation/CarbonEstimation";
import React from "react";
import { BundleLineDTO } from "../../../../../models/BundleDTO";

export type RenderCarbonEstimationProps = {
  bundleLines: BundleLineDTO[],
  handleChangeCarbonEstimation: Function
};
const RenderCarbonEstimation = ({bundleLines, handleChangeCarbonEstimation}: RenderCarbonEstimationProps) => {
  const { t } = useTranslation();
  if (!bundleLines || bundleLines?.length === 0) return null;

  return (
    <div className="carbonEstimationWrapper">
      <div className="main fromLibrary">
        <MaterialTable lines={ bundleLines[0]?.materialLines || [] } updateLines={(newValue) => {
          handleChangeCarbonEstimation({bundleLine: bundleLines[0], value: newValue, formName: "materialLines"})
        }} /> 
        <div className="rightPart">
          <div style={{display: 'flex', flexDirection: "row", gap: "2rem"}}>
            <MaterialTotalWeight t={t} totalWeight={bundleLines[0]?.totalWeight} onChange={ (newValue) => {
              handleChangeCarbonEstimation({bundleLine: bundleLines[0], value: newValue, formName: "totalWeight"})
            }} />
            <MaterialSynthese lines={ bundleLines[0]?.materialLines || [] } isLibraryScreen={true} />
          </div>
          <div className="footerCarbon">
            <ManufacturerIndexTitle t={t} isLibraryScreen={true} />
            <ManufacturerIndexChoice t={t} handleCheckElement={(newValue) => {
              handleChangeCarbonEstimation({bundleLine: bundleLines[0], value: newValue, formName: "manufacturedRate"})
            }} percentValueElementSelected={  bundleLines[0]?.manufacturedRate } isLibraryScreen={true} />
          </div>
        </div>
      </div>
    </div>
  )
};

export default RenderCarbonEstimation;

